import { createColumnHelper } from "@tanstack/react-table";
import { DashboardOrder } from "@/shared/api";

export const visibleColumnNames: Record<string, string> = {
  order_id: "Order ID",
  status: "Status",
  order_source: "Order source",
  stage_statuses: "Stage statuses",
  p_created_at: "Pin created at",
  z_created_at: "Zone created at",
  elapsed_time: "Elapsed time (sec.)",
  time: "Time",
  created_at: "Created at",
  request_id: "Request ID",
  z_f1_score: "Zone F1 score",
  z_true_positives_count: "Zone true positive count",
  z_false_positives_count: "Zone false positive count",
  z_false_negatives_count: "Zone false negative count",
  p_f1_score: "Pin F1 score",
  p_true_positives_count: "Pin true positive count",
  p_false_positives_count: "Pin false positive count",
  p_false_negatives_count: "Pin false negative count",
  journey_count: "Journey count",
  pipeline_version: "Pipeline version",
  pipeline_description: "Pipeline description",
};

export const columnHelper = createColumnHelper<DashboardOrder>();

export const getInitialSorting = (searchParams: URLSearchParams) => {
  const defaultSorting = [{ id: "requested_at", desc: true }];

  const orderingColumnKeys = searchParams.get("ordering")?.split(",");
  const orderings = orderingColumnKeys?.map((key) => ({
    id: key.replace("-", ""),
    desc: key.startsWith("-") ? true : false,
  }));

  return orderings || defaultSorting;
};

export const getInitialFilters = (searchParams: URLSearchParams) => {
  const defaultFilters = {};

  return Array.from(searchParams.entries())
    .filter(([key]) => !["page", "limit"].includes(key))
    .reduce((prev, [key, value]) => {
      return { ...prev, [key]: Array.isArray(value) ? value.join(",") : value };
    }, defaultFilters);
};
